import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    getWhatsAppStatus,
    sendWhatsAppMessage,
    sendBulkWhatsApp,
    listenWhatsAppSocket,
    stopWhatsAppSocketListeners,
} from "./WhatsAppAction";
import "./Whatsapp.css";

const WhatsApp = (props) => {
    const {
        socketStatus,
        socketMessage,
        qrCode,
        isSendingWhatsAppMessage,
        getWhatsAppStatus,
        sendWhatsAppMessage,
        listenWhatsAppSocket,
        stopWhatsAppSocketListeners,
    } = props;
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        listenWhatsAppSocket();
        getWhatsAppStatus();
        return () => {
            stopWhatsAppSocketListeners();
        };
    }, []);

    const handleSingleSubmit = (e) => {
        e.preventDefault();
        const body = { phone, message };

        sendWhatsAppMessage(
            body,
            (msg) => console.log("Success:", msg),
            () => console.log("Failed")
        );
    };


    return (
        <div className="wa-container">
            <div className="wa-card">

                <h2>WhatsApp SMS Panel</h2>

                {/* Status */}
                <div className={`wa-status ${socketStatus}`}>
                    ● {socketStatus?.toUpperCase()} — {socketMessage}
                </div>

                {/* QR */}
                {qrCode && socketStatus === "qr" && (
                    <div className="wa-qr">
                        <p>Scan this QR in WhatsApp → Linked Devices</p>
                        <img src={qrCode} alt="QR Code" />
                    </div>
                )}

                {/* Forms */}
                {socketStatus === "connected" && (
                    <>
                        {/* Single SMS */}
                        <form onSubmit={handleSingleSubmit} className="wa-form">
                            <h3>Send Single Message</h3>

                            <input
                                type="text"
                                placeholder="Phone (923xxxxxxxxx)"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                            />

                            <textarea
                                placeholder="Type your message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                            />

                            <button type="submit" disabled={isSendingWhatsAppMessage}>
                                {isSendingWhatsAppMessage ? "Sending" : "Send Message"}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    socketStatus: state.WhatsAppReducer.socketStatus,
    socketMessage: state.WhatsAppReducer.socketMessage,
    qrCode: state.WhatsAppReducer.qrCode,
    isSendingWhatsAppMessage: state.WhatsAppReducer.isSendingWhatsAppMessage,
    isSendingBulkWhatsApp: state.WhatsAppReducer.isSendingBulkWhatsApp,
});

const mapDispatchToProps = (dispatch) => ({
    getWhatsAppStatus: (...args) => dispatch(getWhatsAppStatus(...args)),
    sendWhatsAppMessage: (...args) => dispatch(sendWhatsAppMessage(...args)),
    sendBulkWhatsApp: (...args) => dispatch(sendBulkWhatsApp(...args)),
    listenWhatsAppSocket: () => dispatch(listenWhatsAppSocket()),
    stopWhatsAppSocketListeners: () => dispatch(stopWhatsAppSocketListeners()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WhatsApp);